import { differenceInCalendarDays, differenceInMonths, differenceInYears, format, isSameDay, isSameMonth, parseISO } from 'date-fns';

export const TODAY = new Date(2026, 10, 4);

const AVATAR_COLORS = ['#0b1857', '#189ad3', '#005073', '#ff7a00', '#5b4fc4', '#1f8a65', '#b8336a', '#2f6fd1', '#0e7490', '#9a5b13'];

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  const first = parts[0][0];
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return `${first}${last}`.toUpperCase();
}

export function avatarColor(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}

export function formatDate(iso: string, pattern = 'MMM d, yyyy'): string {
  return format(parseISO(iso), pattern);
}

export function formatRange(start: string, end: string): string {
  const s = parseISO(start);
  const e = parseISO(end);
  if (isSameDay(s, e)) return format(s, 'MMM d');
  if (isSameMonth(s, e)) return `${format(s, 'MMM d')} – ${format(e, 'd')}`;
  return `${format(s, 'MMM d')} – ${format(e, 'MMM d')}`;
}

export function formatDays(n: number): string {
  return `${n} ${n === 1 ? 'day' : 'days'}`;
}

export function tenure(hireIso: string): string {
  const months = Math.max(0, differenceInMonths(TODAY, parseISO(hireIso)));
  return `${Math.floor(months / 12)}y ${months % 12}m`;
}

export function age(birthIso: string): number {
  return differenceInYears(TODAY, parseISO(birthIso));
}

export function relativeDay(iso: string): string {
  const diff = differenceInCalendarDays(TODAY, parseISO(iso));
  if (diff === 0) return 'Today';
  if (diff === 1) return 'Yesterday';
  if (diff > 1) return `${diff} days ago`;
  return formatDate(iso, 'MMM d');
}
